import { Box, Stack, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

import { Button } from "../../../components/Button";

const NOOP = () => {};

export const LOCKED_BLUR_SX: SxProps<Theme> = {
  filter: "blur(4px)",
  userSelect: "none",
  pointerEvents: "none",
};

const OVERLAY_TOP_OFFSET_FOR_AUTHOR_SECTION = "10%";

interface LockedReviewOverlayProps {
  isLocked: boolean;
  onUnlockPress?: () => void;
  children: ReactNode;
  anchorOverlayToParent?: boolean;
}

export function LockedReviewOverlay(props: LockedReviewOverlayProps) {
  const { isLocked, onUnlockPress = NOOP, children, anchorOverlayToParent = false } = props;

  if (!isLocked) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        position: anchorOverlayToParent ? undefined : "relative",
        marginTop: anchorOverlayToParent ? undefined : 4,
      }}
    >
      <Box
        aria-hidden="true"
        sx={{
          ...LOCKED_BLUR_SX,
          minHeight: "4rem",
        }}
      >
        {children}
      </Box>

      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          position: "absolute",
          top: anchorOverlayToParent ? OVERLAY_TOP_OFFSET_FOR_AUTHOR_SECTION : 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        <Button
          variant="contained"
          size="medium"
          startIconType="locked"
          onClick={(event) => {
            event.stopPropagation();
            onUnlockPress();
          }}
        >
          Leave a review to unlock
        </Button>
      </Stack>
    </Box>
  );
}
